import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/paymentReducer'

export { selectors }

export default function usePayment(selector) {
  return useSelector(state => selector(state.payment), shallowEqual)
}